var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"bg-light d-flex flex-column m-0 p-0"},[_c('header',{staticClass:"d-flex flex-nowrap align-items-center bg-primary p-2"},[_c('Me'),_c('h1',{staticClass:"text-center flex-grow-1 text-dark pr-5 float-top w-100"},[_vm._v("Verben Konjugieren")])],1),_c('router-view'),_c('FooterVue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }